module.exports = __webpack_public_path__ + "img/lawlex-accordion-lock.b28e819a.svg";